<template>
  <div class='main'>
    <!-- <el-button size="small" class="download" @click="download">下载</el-button> -->
    <!-- <img alt="" :src="require('@/assets/images/back.png')"> -->
    <div class='main-logo'>
      <img alt='' :src="require('@/assets/images/logo-k.png')">
    </div>
    <div class='main-text'>
      <p>
        <span class='login-text-left'>民生精神</span>
        <span class='login-text-right'>：爱国主义 集体主义 艰苦创业 拼搏献身</span>
      </p>
      <p>
        <span class='login-text-left'>民生价值观</span>
        <span class='login-text-right'>：民生公司最后的意义绝不是帮助本身，</span>
        <span class='login-text-right-two'>而是帮助社会。</span>
      </p>
    </div>
    <div class='main-video'>
      <!-- <video
        :src="require('@/assets/bg.mp4')"
        :controls="videoOptions.controls"
        webkit-playsinline="true"
        playsinline="true"
        x-webkit-airplay="allow"
        x5-playsinline
        width="100%"
        height="110%"
        autoplay=""
        loop=""
        muted="muted"
        ref="video">
      </video> -->
      <img alt='' :src="require('@/assets/images/logo-c.jpg')" style='width: 100%;height: 100%'>
    </div>
    <div class='content'>
      <div class='loginContainer'>
        <div class='loginTitle'>{{ loginTitle }}</div>
        <div class='loginSubtitle'>{{ subtitle }}</div>
        <el-form :model='form' v-show='!phoneshow' style='width: 100%;' label-width='100%'
                 label-position='left' :inline='true'>
          <el-form-item prop='phone' style='width:100%' class='form-label' label='登录账号'>
            <el-input v-model='form.user' placeholder='请输入登录账号' autocomplete='off' size='medium' />
          </el-form-item>
          <el-form-item prop='phone' style='margin-bottom: 10px;width:100%' label='登录密码'>
            <el-input v-model='form.pass' placeholder='请输入登录密码' autocomplete='off' size='medium'
                      type='password' />
            <!-- <span class="span-a" @click="forgetPass">忘记密码?</span> -->
          </el-form-item>
          <!--          <el-form-item style='margin-bottom: 10px;width:100%' label='用户类型'>
                      <el-select v-model='form.source' placeholder='请选择'>
                        <el-option
                          v-for='item in options'
                          :key='item.value'
                          :label='item.label'
                          :value='item.value'>
                        </el-option>
                      </el-select>
                    </el-form-item>-->
          <!--          <el-form-item>
                      <el-radio-group v-model='form.source'>
                        <el-radio label='0'>平台</el-radio>
                        <el-radio label='1'>公路供应商</el-radio>
                        <el-radio label='2'>水路供应商</el-radio>
                      </el-radio-group>
                    </el-form-item>-->
          <el-form-item>
            <div class='forget'>
              <el-checkbox v-model='checked'>记住密码</el-checkbox>
              <router-link target='_blank' style='color:#409EFF;cursor:pointer;'
                           :to="{path:'/download'}">下载
              </router-link>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button
              style='height:40px;background: #286fda;font-weight: 600;'
              :loading='butLoad'
              @click='loginBefore'
              type='primary'
              size='medium'>登录
            </el-button>
          </el-form-item>
          <!-- <el-form-item>
            <span class="copyright">渝ICP备2022002327号-1</span>
          </el-form-item> -->
        </el-form>
        <el-form
          v-show='phoneshow'
          ref='forgetForm'
          :model='forgetForm'
          :rules='rules'
          style='width: 100%;'
          label-width='100%'
          label-position='left'
          :inline='true'>
          <el-form-item label='手机号码：' style='width:100%' prop='phone'>
            <el-input
              v-model='forgetForm.phone'
              placeholder='请输入绑定手机账号'
              autocomplete='off'
              size='medium' />
          </el-form-item>
          <el-form-item label='验证码：' style='width:100%' prop='code'>
            <el-input
              class='verify'
              :style="'min-width:210px;margin-right:10px'"
              v-model='forgetForm.code'
              placeholder='请输入验证码'
              autocomplete='off'
              size='medium' />
            <div class='getCode' :class='{ gray: codestate }'>
              {{ codeText }}
            </div>
          </el-form-item>
          <el-form-item label='新密码：' style='width:100%' prop='pass'>
            <el-input
              type='password'
              v-model='forgetForm.pass'
              placeholder='8-16位的数字加字母组合密码'
              autocomplete='new-password'
              size='medium' />
          </el-form-item>
          <el-form-item label='确认密码：' style='width:100%' prop='passconfirm'>
            <el-input
              :style="'min-width:210px;marg'"
              type='password'
              v-model='forgetForm.passconfirm'
              placeholder='请再次输入新密码'
              autocomplete='new-password'
              size='medium'
            />
          </el-form-item>
          <el-form-item>
            <el-button size='medium' type='primary' @click='confirmPassword'>确认</el-button>
            <el-button size='medium' @click='forgetCancel()'>取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <footer>
      <div>
        <span>渝ICP备2022002327号-1</span>
        <!-- <span>没有账户吗?</span>
        <a href="#">联系我们</a> -->
      </div>
    </footer>
  </div>
</template>

<script>
  import {
    setLocalStore,
    getLocalStore, setSessionStore, removeSessionStore,
  } from '@/config/mUtils';
  import { applicationAreaInfo, login } from '@/service/getData';

  export default {
    components: {},
    data() {
      // 验证两次输入密码是否正确
      const validatePass = (rule, value, callback) => {
        const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/;
        if (!reg.test(value)) {
          callback(new Error('密码为长度8-16数字和英文组合'));
        } else if (value !== this.forgetForm.pass) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };

      const validatorPwd = (rule, value, callback) => {
        const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/;
        if (!reg.test(value)) {
          callback(new Error('密码为长度8-16数字和英文组合'));
        } else {
          callback();
        }
      };

      // 验证手机号码是否输入正确
      const validPhone = function(rule, value, callback) {
        // 判断是否为空
        if (value === '') {
          callback(new Error('电话号码不能为空'));
          return;
        }
        // 电话号码正则
        const res = /^1[3|4|5|7|8|9][0-9]{9}$/;
        // 判断是否成立
        if (!res.test(value)) {
          callback(new Error('电话号码输入有误'));
          return;
        }
        callback();
      };
      return {
        options: [{
          label: '公司',
          value: '0',
        }, {
          label: '公路供应商',
          value: '1',
        }, {
          label: '水路供应商',
          value: '2',
        }],
        loginTitle: '欢迎回来！',
        subtitle: '民生整车物流信息管理平台-登录',
        form: {
          user: '', // admin
          pass: '', // admin
          source: '0',
        },
        phoneshow: false, // 忘记密码显示
        butLoad: false,
        checked: false, // 记住密码
        // 忘记密码
        forgetForm: {
          phone: '',
          code: '',
          pass: '',
          passconfirm: '',
        },
        // 表单验证
        rules: {
          phone: [{
            required: true,
            validator: validPhone,
            trigger: 'blur',
          }],
          code: [{
            required: true,
            message: '验证码不能为空',
            trigger: 'blur',
          }],
          pass: [{
            required: true,
            validator: validatorPwd,
            trigger: 'blur',
          }],
          passconfirm: [
            {
              required: true,
              validator: validatePass,
              trigger: 'blur',
            },
          ],
        },
        codestate: false, // 验证码状态
        codeText: '发送验证码', // 文字
        authStringArr: [],


        // 视频播放
        videoOptions: {
          controls: true,
        },
        player: null,
        playTime: '',
        seekTime: '',
        current: '',
      };
    },
    methods: {
      // 登录
      async loginBefore() {
        if (!this.form.user) return this.$message.warning('账号不能为空');
        if (!this.form.pass) return this.$message.warning('请输入密码');
        // await this.$router.push({path: "home"});
        this.butLoad = true;
        await this._getAreaList();
        const res = await login({
          pcOrAppFlag: 1,
          account: this.form.user,
          password: this.form.pass,
          source: this.form.source,
        });
        if (res.status === 0) {
          setSessionStore('token', res.data.access_token);
          setSessionStore('base_refresh_token', res.data.refresh_token);
          setSessionStore('userName', res.data.userName.split(',')[0]);
          setSessionStore('userDept', res.data.essEmployeeDept);
          setSessionStore('isUpdatePwd', res.data.isUpdatePwd);
          setSessionStore('auditMenu', res.data.auditMenu);
          // await this._getAreaList();
          if (res.data.menu != null && res.data.menu.length > 0) {
            if (res.data && res.data.menu.length) {
              this.getAuthId(res.data.menu);
            } else {
              this.authStringArr = [];
            }
          } else {
            this.authStringArr = [];
          }
          if (res.data.auditMenu != null && res.data.auditMenu.length > 0) {
            if (res.data && res.data.auditMenu) {
              this.getAuthId2([res.data.auditMenu]);
            } else {
              this.getAuthId2 = [];
            }
          } else {
            this.getAuthId2 = [];
          }

          // 是否记住用户
          if (this.checked) {
            setLocalStore('baseRemberObj', {
              accout: this.form.user,
              checked: this.checked,
              pass: this.form.pass,
            });
          } else {
            setLocalStore('baseRemberObj', { checked: this.checked });
          }
          setSessionStore('authArr', this.authStringArr);
          await this.$router.push({
            path: 'home',
            query: { first: true },
          });
        } else {
          this.butLoad = false;
          this.$message.error(res.message);
        }
      },

      async _getAreaList() {
        const res = await applicationAreaInfo();
        if (res.status === 0) {
          if (res.data) {
            setSessionStore('areaList', res.data);
          }
        } else {
          this.$message.error(res.message);
        }
      },
      /* 递归获取权限 */
      getAuthId(arr) {
        arr.forEach((item, index) => {
          if (item.id) {
            this.authStringArr.push(item.id);
          }
          if (item.childList && item.childList.length > 0) {
            this.getAuthId(item.childList);
          } else {
            return false;
          }
        });
      },
      /* 递归获取权限 */
      getAuthId2(arr) {
        arr.forEach((item, index) => {
          if (item.url) {
            this.authStringArr.push(item.url);
          }
          if (item.childList && item.childList.length > 0) {
            this.getAuthId2(item.childList);
          } else {
            return false;
          }
        });
      },
      // 忘记密码确定密码
      confirmPassword() {
        this.$refs.forgetForm.validate((valid) => {
          if (valid) {
            this.$message('密码重置成功');
            this.phoneshow = false;
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      // 取消忘记密码
      forgetCancel() {
        this.phoneshow = false;
        this.loginTitle = '欢迎回来！';
        // this.$refs.forgetForm.resetFields();
      },
      // 忘记密码
      forgetPass() {
        this.phoneshow = true;
        this.loginTitle = '忘记密码';
      },
      init() {
        removeSessionStore('token');
        removeSessionStore('areaList');
        removeSessionStore('region');
        removeSessionStore('authArr');

        const obj = JSON.parse(getLocalStore('baseRemberObj'));
        this.checked = obj.checked;
        if (this.checked) this.form.user = obj.accout;
        if (this.checked) this.form.pass = obj.pass;
      },
      enterLogin() {
        const that = this;
        document.onkeydown = function(e) {
          e = window.event || e;
          // 验证在登录界面和按得键是回车键enter
          if (that.$route.path == '/login' && (e.code == 'Enter' || e.code == 'enter')) {
            that.loginBefore();
          }
        };
      },
    },
    created() {
      this.enterLogin();
    },
    mounted() {
      this.init();
    },
  };
</script>

<style lang='scss' scoped>
  @import "src/style/login-element";
  @import "src/style/mixin";

  html,
  body {
    margin: 0; /*清除默认样式*/
    padding: 0;
    height: 100%;
  }

  footer {
    position: fixed;
    bottom: 0px;
    display: block;
    width: 25%;
    min-width: 370px;
    // min-width: 410px;
    right: 0px;
    padding-left: 40px;
    background: #fff;
    border-left: 1px solid #C6C6C6;
    padding-bottom: 1rem;
    z-index: 20;

    div {
      width: 300px;
      text-align: center;
      padding: 0.75rem 1rem;
    }

    span {
      font-size: 0.875rem;
      color: #8c98a4;
    }

    a {
      font-weight: 600;
      font-size: 0.875rem;
      color: #286fda;
      padding-left: 10px;
      text-decoration: underline;
    }
  }

  .content {
    position: absolute;
    width: 25%;
    min-width: 370px;
    right: 0px;
    height: 100vh;
    background: #fff;
    border-left: 1px solid #C6C6C6;
    -webkit-display: flex;
    display: flex;
    -webkit-align-items: center;
    align-items: center;
    -webkit-justify-content: center;
    justify-content: center;
    z-index: 20;
  }

  .main {
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;

    .main-logo {
      position: absolute;
      z-index: 20;
      bottom: 5%;
      right: calc(25% + 30px);

      img {
        width: 100%;
      }
    }

    .main-text {
      position: absolute;
      top: 15%;
      left: 8%;
      z-index: 20;

      p:last-child {
        margin-top: 15px;
      }

      .login-text-left {
        display: inline-block;
        color: #fff;
        font-size: 20px;
        font-weight: 700;
        width: 110px;
        vertical-align: top;
        text-align-last: justify;
        // text-shadow: 1px 2px 3px #fff;
      }

      .login-text-right {
        display: inline-block;
        color: #fff;
        font-size: 20px;
        font-weight: 700;
        width: calc(100% - 120px);
        vertical-align: top;
      }

      .login-text-right-two {
        display: inline-block;
        color: #fff;
        font-size: 20px;
        font-weight: 700;
        width: calc(100% - 120px);
        margin-left: 120px;
      }
    }

    .main-video-bg {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      min-width: 1600px;
      height: 100%;
      z-index: 10;
      background: url(../../assets/images/overlay.png) 100% 100%;
      background-size: cover;
      opacity: 1;
    }

    .main-video {
      position: absolute;
      width: 75%;
      height: 100%;
      top: 0px;
      left: 0px;
      /*left: -192px;*/
      /*display: flex;*/
      /*justify-content: center;*/
      /*align-content: center;*/
    }

    .span-a {
      position: absolute;
      display: inline-block;
      top: -30px;
      right: 0px;
      color: rgb(51, 204, 255);
      text-decoration: underline;
      font-size: 13px;
      line-height: 1.6;
      color: #8c98a4;
      border-bottom: 0.0625rem dashed #97a4af;
      cursor: pointer;

      &:hover {
        cursor: pointer;
      }
    }

    .copyright {
      display: block;
      min-width: 300px;
      color: #677788;
      text-align: center;
    }

    .loginContainer {
      // width: 500px;
      width: 100%;
      // min-width: 410px;
      border: none;
      // border-left:1px solid #C6C6C6;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 30px 0 40px;
      background-color: rgba(255, 255, 255, 1);
      // position: relative;
      z-index: 40;

      .loginTitle {
        display: inline-block;
        width: 100%;
        font-size: 1.25rem;
        font-weight: 600;
        text-align: left;
        margin-bottom: 0.5rem;
        line-height: 1.2;
        color: #000;
      }

      .loginSubtitle {
        display: block;
        width: 100%;
        margin-top: 0;
        margin-bottom: 1rem;
        font-size: 0.875rem;
        font-family: 'Microsoft-Yahei', 'Open Sans', sans-serif;
        font-weight: 400;
        line-height: 1.6;
        color: #677788;
        text-align: left;
      }

      .forget {
        @include fj();
        align-items: center;

        .span-b {
          color: rgb(51, 204, 255);
          text-decoration: underline;
          font-size: 12px;

          &:hover {
            cursor: pointer;
          }
        }

        .span-b {
          cursor: pointer;
        }
      }
    }

    .getCode {
      vertical-align: middle;
      cursor: pointer;
      float: right;
      display: inline-block;
      width: 80px;
      height: 30px;
      line-height: 30px;
      background: #18b3d9;
      border-radius: 3px;
      text-align: center;
      color: #fff;
      font-size: 12px;
      margin-top: 6px;
    }

    .gray {
      background-color: #909399;
    }
  }

  ::v-deep {
    .el-form-item__label {
      font-size: 14px;
      color: rgb(12, 11, 11);
      font-weight: 500;
    }

    .el-form-item__content {
      width: 100%;
      min-width: 300px;
    }

    .el-button--medium {
      width: 100%;
    }

    .verify.el-input.el-input--medium {
      width: calc(100% - 90px);
    }
  }

  .download {
    position: absolute;
    right: 30px;
    top: 10px;
    z-index: 100;
  }

  .el-select {
    width: 100%;
  }
</style>
